export const MAX_MODULE_DURATION_SECONDS = 180;
export const CORRECT_SCORE = 1.0;
export const MAX_NUMBER_OF_RECENT_SECTION_EVENTS = 10;
